import { useState } from "react";
import SimpleMDE from "react-simplemde-editor";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { H3, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Instructions, SecondExample } from "../../../../Constant";

const MdeExampleTwo = () => {
  const [value, setValue] = useState("");
  const handelChange = (newValue: string) => setValue(newValue)
  const MNDeditortext = "Enter text in the area on the left. For more info, click the ? (help) icon in the menu.";

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={SecondExample} />
            <CardBody>
              <Row className="editor_container">
                <Col md="6">
                  <SimpleMDE id="editor_container" options={{ autofocus: true, spellChecker: false }} onChange={handelChange} />
                </Col>
                <Col md="6" className="reader">
                  <H3>{Instructions}</H3>
                  <P>{MNDeditortext}</P>
                  <br />
                  {value}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default MdeExampleTwo;
